export default function initPopup() {
  document.querySelectorAll('.popup').forEach(popup => {
    const body = document.querySelector('body');
    const openedClass = 'modal-opened';
    const closeBtns = popup.querySelectorAll('[data-close]');
    const simpleBtns = popup.querySelectorAll('.btn');
    const key = 'is-cahsed';
    const now = new Date();

    if(localStorage.getItem(key) >= now.getTime()) return;

    function setWithExpiry(key, ttl) {
      localStorage.setItem(key, now.getTime() + ttl * 24 * 60 * 60 * 1000);
    }

    setTimeout(()=>{
      body.classList.add(openedClass)
    }, popup.dataset.delay * 1000)

    const closePopup = e => {
      body.classList.remove(openedClass);
      popup.dataset?.days && setWithExpiry(key, popup.dataset?.days);
    }

    closeBtns.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        closePopup();
      })
    })

    simpleBtns.forEach(btn => {
      btn.addEventListener('click', e => {
        closePopup();
      })
    })
  })
}